import React, { useEffect, useState } from "react";

import "./AccountSettings.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { auth, firestoredb, uploadImg } from "../../../firebase/firebase";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import {
  EmailAuthProvider,
  onAuthStateChanged,
  reauthenticateWithCredential,
  updatePassword,
  updateProfile,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
function AccountSetting() {
  const [passModal, setPassModal] = useState(false);

  const [passwordUpdate, setPasswordUpdate] = useState(true);
  const handlePassClose = () => setPassModal(false);
  const handlePassShow = () => setPassModal(true);
  const saveChanges = () => setPasswordUpdate(false);

  const [profileImage, setProfileImage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [errorObj, setErrorObj] = useState({});
  const [userisLogged, setUserisLogged] = useState();
  const [userData, setUserData] = useState();
  const [isLoading, setisLoading] = useState();
  const [oldPassword, setoldPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [resetError, setResetError] = useState(false);
  const navigate = useNavigate();

  const validation = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    console.log(!emailRegex.test(email));
    let obj = {
      profileImage: false,
      firstName: false,
      lastName: false,
      email: false,
      dob: false,
      phone: false,
    };
    if (profileImage == "") {
      obj.profileImage = true;
    }
    if (firstName == "") {
      obj.firstName = true;
    }
    if (lastName == "") {
      obj.lastName = true;
    }
    if (email == "" || !emailRegex.test(email)) {
      obj.email = true;
    }
    if (dob == "") {
      obj.dob = true;
    }
    if (phone == "") {
      obj.phone = true;
    }
    return obj;
  };

  const onSubmit = async () => {
    // const valid = validation()
    // console.log(valid);
    // setErrorObj(valid)
    // if (valid.profileImage || valid.firstName || valid.lastName || valid.email || valid.dob || valid.phone) {
    //   console.log("err");
    // } else {
    // console.log(profileImage);
    // console.log(firstName);
    // console.log(lastName);
    // console.log(email);
    // console.log(dob);
    // console.log(phone);
    // }
    if (profileImage == "") {
      console.log("please select profile <imag></imag>e");
      toast("Please Select Profile Image");
    } else {
      await uploadImg(profileImage, userisLogged)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (firstName != "" || lastName != "") {
      const fullname = firstName + " " + lastName;
      await setDoc(
        doc(firestoredb, "Users", userisLogged.uid),
        {
          firstName: firstName,
          lastName: lastName,
          dateOfBirth: dob,
          phoneNumber: phone,
        },
        { merge: true }
      )
        .then((res) => {
          updateProfile(userisLogged, { displayName: fullname });
          toast("Profile Updated Successfully", { toastId: "profilesuccess" });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast("Please put firstname and lastname ", {
        toastId: "firstnamelastname",
      });
    }
  };

  const getUserData = async () => {
    if (userisLogged) {
      const docRef = doc(firestoredb, "Users", userisLogged.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setUserData(docSnap.data());
        setEmail(docSnap.data().email);
        setDob(docSnap.data().dateOfBirth);
        setFirstName(docSnap.data().firstName);
        setLastName(docSnap.data().lastName);
        setPhone(docSnap.data().phoneNumber);
        // setProfileImage(userisLogged.photoURL)
      } else {
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }
    }
  };

  useEffect(() => {
    getUserData();
  }, [userisLogged]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
      } else {
        setUserisLogged(user);
      }
    });
    return () => unsubscribe();
  }, []);

  const passwordResetValidation = () => {
    let obj = {
      oldPassword: false,
      newPassword: false,
      confirmPassword: false,
    };
    if (oldPassword == "" || oldPassword == undefined) {
      obj.oldPassword = true;
    }
    if (newPassword == "" || newPassword == undefined) {
      obj.newPassword = true;
    }
    if (confirmPassword == "" || confirmPassword == undefined) {
      obj.confirmPassword = true;
    }
    return obj;
  };

  const passwordReset = () => {
    // setPasswordUpdate(false)
    console.log(oldPassword);
    console.log(newPassword);
    console.log(confirmPassword);
    const validReset = passwordResetValidation();

    console.log(validReset);
    setResetError(validReset);
    if (
      validReset.confirmPassword ||
      validReset.newPassword ||
      validReset.oldPassword
    ) {
    } else {
      if (newPassword == confirmPassword) {
        const credential = EmailAuthProvider.credential(
          userisLogged.email,
          oldPassword
        );

        reauthenticateWithCredential(userisLogged, credential)
          .then(() => {
            // setisLoading(false);
            // User re-authenticated.
            updatePassword(userisLogged, newPassword)
              .then(() => {
                // Update successful.

                toast.success("Password Changed!", {
                  toastId: "passwordChanged",
                });
                window.location.reload(false);
                setisLoading(false);
              })
              .catch(async (error) => {
                setisLoading(false);
                console.log(error);
              });
          })
          .catch((err) => {
            // An error ocurred
            // ...
            console.log(err);
            toast.error("Old Password is not correct", {
              toastId: "OldPasswordError",
            });
            setisLoading(false);
          });
      } else {
        toast("Password does not match", { toastId: "passnotmatch" });
      }
    }
  };

  return (
    <div>
      <div className="account-setting">
        <div className="account-setting-content">
          <div className="profile input-box">
            <div className="profile-img">
              <label htmlFor="profileImg">
                {profileImage ? (
                  <img
                    src={URL.createObjectURL(profileImage)}
                    alt=""
                    className="img-100"
                  />
                ) : userisLogged?.photoURL ? (
                  <img
                    src={userisLogged?.photoURL}
                    alt=""
                    className="img-100"
                  />
                ) : (
                  <img
                    src="\assets\images\profile-img.png"
                    alt=""
                    className="img-100"
                  />
                )}
                <p className="para">Edit your profile</p>
              </label>
              <input
                type="file"
                id="profileImg"
                className="d-none"
                onChange={(e) => setProfileImage(e.target.files[0])}
              />
            </div>

            <div className="profile-name">
              <div className="upper">
                <p className="para">
                  First Name <span>*</span>
                </p>
                <input
                  value={firstName}
                  type="text"
                  name=""
                  id=""
                  placeholder="Enter your name"
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {/* {
                  errorObj.firstName ? <p className="error-obj">Please Enter Name here</p> : <></>
                } */}
              </div>
              <div className="lower mt-3">
                <p className="para">
                  Last Name <span>*</span>
                </p>
                <input
                  value={lastName}
                  type="text"
                  name=""
                  id=""
                  placeholder="Enter your name"
                  onChange={(e) => setLastName(e.target.value)}
                />
                {/* {
                  errorObj.lastName ? <p className="error-obj">Please Enter Last Name here</p> : <></>
                } */}
              </div>
            </div>
          </div>
          {/* {
            errorObj.profileImage ? <p className="error-obj">Please Upload Profile Image here</p> : <></>
          } */}
          <div className="input-box email">
            <p className="para">Email Address</p>
            <input
              value={email}
              type="email"
              name=""
              id=""
              placeholder="Enter your email"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              disabled
            />
            {/* {
              errorObj.email ? <p className="error-obj">Please Enter Valid Email here</p> : <></>
            } */}
          </div>
          <div className="input-box DOB">
            <p className="para">Date of Birth</p>
            <input
              value={dob}
              type="date"
              name=""
              id=""
              onChange={(e) => setDob(e.target.value)}
            />
            {/* {
              errorObj.dob ? <p className="error-obj">Please Enter Dob here</p> : <></>
            } */}
          </div>
          {/* <div className="input-box connect-wallet">
            <p className="para">Connect Wallet</p>
            <div className="input-box-1 d-flex align-items-center">
              <p className="mb-0 body-large text-light-grey">
                <img
                  src="\assets\images\Account-setting\MetaMask.svg"
                  alt="Metamask"
                  className="me-2"
                />
                Metamask
                <span className="ms-5 text-white">1X05542.215.1854vqs564</span>
              </p>

              <div className="unbind-btn">
                <button>Unbind</button>
              </div>
            </div>
          </div> */}
          <div className="input-box Mobile">
            <p className="para">Mobile</p>
            <div className="hello  d-flex">
              <input
                value={phone}
                type="number"
                name=""
                id=""
                placeholder="+92 301 2345 678"
                onChange={(e) => setPhone(e.target.value)}
              />
              {/* <p className="para body-large text-light-grey verify">
                (Verified)
              </p> */}
            </div>
            {/* {
              errorObj.phone ? <p className="error-obj">Please Enter Phone Number here</p> : <></>
            } */}
          </div>
          <div className="buttons">
            <div className="change-password">
              <button onClick={handlePassShow}>Change Password</button>
            </div>
            <div className="changes">
              <div className="discard-changes">
                <button
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Discard Changes{" "}
                </button>
              </div>
              <div className="save-changes">
                <button onClick={onSubmit}>Save Changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={passModal}
        onHide={handlePassClose}
        animation={false}
        centered
        className="password-modal"
      >
        <Modal.Header className="modal-header" closeButton>
          <Modal.Title className="modal-title">
            {passwordUpdate ? (
              <h2 className="body-medium ">Change Password</h2>
            ) : (
              <h2 className="body-medium ">Changes Saved</h2>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          {passwordUpdate ? (
            <div className="">
              <p className="para text-light-grey">
                In order to change password please enter your old password.
              </p>
              <input
                type="password"
                name=""
                id=""
                placeholder="Enter Old Password"
                onChange={(e) => {
                  setoldPassword(e.target.value);
                }}
              />
              {resetError.oldPassword ? (
                <p className="error-obj">Please Old Password here</p>
              ) : (
                <></>
              )}
              <p className="para text-light-grey mt-3">
                New password should not match the older password and must a
                letter, number and sign(,._)
              </p>
              <input
                type="password"
                name=""
                id=""
                placeholder="Enter New Password"
                onChange={(e) => setNewPassword(e.target.value)}
              />
              {resetError.newPassword ? (
                <p className="error-obj">Please Old Password here</p>
              ) : (
                <></>
              )}
              <input
                type="password"
                name=""
                id=""
                placeholder="Confirm New Password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {resetError.confirmPassword ? (
                <p className="error-obj">Please Old Password here</p>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <div className=" body-content d-flex flex-column align-items-center justify-content-center">
              <div className="body-img ">
                <img src="\assets\images\ChangesSaved.png" alt="" />
              </div>
              <p className="para text-light-grey mt-5">
                All the Changes are saved
              </p>
            </div>
          )}
          {/* when changes done */}
        </Modal.Body>
        <div className="modal-footer ">
          {passwordUpdate ? (
            <div className="modal-footer-btn">
              <button
                className="discard"
                variant="secondary"
                onClick={handlePassClose}
              >
                Discard Changes
              </button>
              <button
                className="save"
                variant="primary"
                onClick={passwordReset}
              >
                Save Changes
              </button>
            </div>
          ) : (
            <div className="w-100 m-auto vh-center">
              <Button
                className="save w-75  mb-5 "
                variant="secondary"
                onClick={handlePassClose}
              >
                ok
              </Button>
            </div>
          )}
        </div>

        {/* when changes done */}
      </Modal>
    </div>
  );
}

export default AccountSetting;
